export default class ErrorMessage {
  static missingParameter(parameters) {
    return Promise.reject({
      name: 'Missing Parameters',
      expected: '',
      found: parameters,
    });
  }
}



// WEBPACK FOOTER //
// ./src/helpers/ErrorMessage.js